// Mock data for EasySpanishInsurance - Frontend only

export const heroFeatures = [
  'Holiday Homes',
  'Permanent Homes',
  'Rental Properties',
  'Apartments',
  'Villas',
];

export const insuranceProducts = [
  {
    id: 'home',
    icon: 'Home',
    title: 'Home Insurance',
    description:
      'Comprehensive cover for your Spanish property. Compare quotes from trusted insurers in minutes.',
    cta: 'Compare Home Insurance',
    href: '/home-insurance',
    available: true,
  },
  {
    id: 'health',
    icon: 'HeartPulse',
    title: 'Health Insurance',
    description:
      'Private health cover for expats and non-residents. Fast, English-speaking service across Spain.',
    cta: 'Compare Health Insurance',
    href: '/health-insurance',
    available: true,
  },
  {
    id: 'community',
    icon: 'Building2',
    title: 'Community Insurance',
    description:
      'Coverage for communities of owners (Comunidad de Propietarios). Launching soon.',
    cta: 'Coming Soon',
    href: '#',
    available: false,
  },
];

export const whyChoose = [
  { icon: 'Languages', title: 'English speaking', text: 'Full support in English across every step.' },
  { icon: 'Languages', title: 'Swedish speaking', text: 'Personlig service på svenska.' },
  { icon: 'Languages', title: 'German speaking', text: 'Beratung auf Deutsch verfügbar.' },
  { icon: 'Languages', title: 'Spanish speaking', text: 'Atención en español nativo.' },
  { icon: 'ShieldCheck', title: 'Trusted insurers', text: 'Policies from A-rated Spanish and international insurers.' },
  { icon: 'FileSearch', title: 'Compare existing insurance', text: 'Upload your current policy and see if you can save.' },
  { icon: 'Users', title: 'Non-resident specialists', text: 'Dedicated to foreign property owners in Spain.' },
  { icon: 'Zap', title: 'Fast online application', text: 'Complete the whole process in under 10 minutes.' },
];

export const howItWorks = [
  { step: 1, title: 'Fill in your property', text: 'Address, size, features and how you use it.' },
  { step: 2, title: 'Answer a few questions', text: 'Construction, security, contents and claims.' },
  { step: 3, title: 'Receive your quote', text: 'Live comparison of premiums from top insurers.' },
  { step: 4, title: 'Accept online', text: 'Sign digitally and receive your policy by email.' },
];

export const reviews = [
  { name: 'Barbara', location: 'Estepona', text: 'I compared my home insurance in minutes and saved almost 40% on the annual premium. Excellent service.' },
  { name: 'Reidar', location: 'Casares Costa', text: 'Perfect for non-residents. Everything in English and the quote arrived instantly.' },
  { name: 'Lisa', location: 'Nerja', text: 'Finally an insurance broker that understands foreign owners. Straightforward and honest.' },
  { name: 'Anna-Karin', location: 'Manilva', text: 'Fast, clear and affordable. My holiday home is now properly covered.' },
];

export const faqs = [
  {
    q: 'Do I need home insurance in Spain as a non-resident?',
    a: 'It is not legally required unless you have a mortgage, but strongly recommended. Non-resident properties are often left empty for long periods, making them vulnerable to water damage, break-ins and storms.',
  },
  {
    q: 'What does Spanish home insurance typically cover?',
    a: 'Standard policies cover building (Continente), contents (Contenido), third-party liability (Responsabilidad Civil), water damage, theft and legal defence. Add-ons include glass breakage, garden furniture and rental protection.',
  },
  {
    q: 'Can I keep my existing insurance and just compare?',
    a: 'Yes. Upload your current policy schedule and we will compare it against several alternatives so you can decide with the numbers in front of you.',
  },
  {
    q: 'How long does a quote take?',
    a: 'Under 10 minutes for most standard properties. Complex villas with high sums insured may take a little longer.',
  },
  {
    q: 'Which insurers do you compare?',
    a: 'We compare policies from leading Spanish and international insurers including Mapfre, Allianz, Liberty, Zurich, AXA and Caser.',
  },
  {
    q: 'Can I pay monthly?',
    a: 'Most of our partner insurers offer annual, semi-annual or monthly direct debit payments with no surcharge.',
  },
  {
    q: 'What if I have had claims in the past?',
    a: 'Previous claims may affect your premium but rarely prevent cover. Be honest so your policy is valid when you need it.',
  },
  {
    q: 'How does health insurance work for non-residents?',
    a: "Private health insurance gives you access to Spain's excellent private hospitals in English. It is required for many non-lucrative visas and NIE-based residencies.",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: '7 Things Every Non-Resident Should Know About Spanish Home Insurance',
    date: '12 June 2025',
    excerpt: 'From "Continente" vs "Contenido" to unoccupied clauses \u2013 the essentials before you sign.',
    tag: 'Home Insurance',
  },
  {
    id: 2,
    title: 'How to Compare Health Insurance in Spain as an Expat',
    date: '3 May 2025',
    excerpt: 'Copay vs no-copay, waiting periods, English-speaking doctors and dental cover explained.',
    tag: 'Health Insurance',
  },
  {
    id: 3,
    title: 'Empty Home for the Winter? Read This First',
    date: '18 April 2025',
    excerpt: 'Many policies restrict cover on properties left empty over 60 days. Here is how to stay protected.',
    tag: 'Home Insurance',
  },
  {
    id: 4,
    title: 'Community Insurance in Spain: Who Pays for What?',
    date: '2 March 2025',
    excerpt: 'Understanding the split between community policies and your private home insurance.',
    tag: 'Community',
  },
];

export const provinces = [
  'Alicante', 'Almería', 'Barcelona', 'Cádiz', 'Castellón', 'Girona', 'Granada', 'Huelva',
  'Illes Balears', 'Las Palmas', 'Málaga', 'Murcia', 'Santa Cruz de Tenerife', 'Tarragona', 'Valencia',
];

export const propertyTypes = [
  'Apartment', 'Villa', 'Townhouse', 'Semi-detached', 'Country house', 'Commercial',
];

export const constructionTypes = ['Concrete', 'Wood', 'Mixed'];
export const roofTypes = ['Flat', 'Tiled', 'Sloped'];
export const insurers = ['Mapfre', 'Allianz', 'Liberty', 'Zurich', 'AXA', 'Caser', 'Generali', 'Other'];

// Mock quote generator based on inputs
export function generateQuotes(data) {
  const base = 180;
  const sizeFactor = ((parseInt(data.builtM2, 10) || 100) / 100) * 90;
  const bedroomsFactor = (parseInt(data.bedrooms, 10) || 2) * 12;
  const poolFactor = data.swimmingPool ? 45 : 0;
  const rentalFactor = data.rentalProperty ? 120 : 0;
  const vacantFactor = data.vacant ? 65 : 0;
  const contentsFactor = ((parseInt(data.furnitureValue, 10) || 15000) / 15000) * 40;
  const claimsFactor = data.anyClaims ? (parseInt(data.claimsCount, 10) || 1) * 55 : 0;
  const securityDiscount = (data.alarm ? -25 : 0) + (data.securityDoor ? -12 : 0) + (data.securityCompany ? -35 : 0);

  const total =
    base + sizeFactor + bedroomsFactor + poolFactor + rentalFactor + vacantFactor + contentsFactor + claimsFactor + securityDiscount;

  const round = (n) => Math.max(120, Math.round(n));

  return [
    { insurer: 'Mapfre',   premium: round(total * 1.05), rating: 4.6, highlights: ['Continente + Contenido', '24/7 English helpline', 'Water damage'] },
    { insurer: 'Allianz',  premium: round(total * 0.98), rating: 4.7, highlights: ['Full building cover', 'Legal defence', 'Glass breakage'] },
    { insurer: 'Liberty',  premium: round(total * 0.92), rating: 4.5, highlights: ['Expat specialist', 'Unoccupied cover 90 days', 'Third-party liability'] },
    { insurer: 'Zurich',   premium: round(total * 1.10), rating: 4.8, highlights: ['Premium villa cover', 'Art & jewellery', 'Emergency callout'] },
    { insurer: 'AXA',      premium: round(total * 1.02), rating: 4.4, highlights: ['Rental-friendly clauses', 'Contents up to \u20ac60k', 'Storm damage'] },
  ].sort((a, b) => a.premium - b.premium);
}

// Age-based Spanish private health-insurance quote generator (illustrative)
export const HEALTH_INSURERS = [
  { name: 'Sanitas',    rating: 4.7 },
  { name: 'Adeslas',    rating: 4.6 },
  { name: 'DKV',        rating: 4.5 },
  { name: 'AXA Salud',  rating: 4.4 },
  { name: 'Asisa',      rating: 4.3 },
];

export function generateHealthQuotes(data) {
  const applicants = data.applicants || [];
  const round = (n) => Math.max(28, Math.round(n));
  const ageFactor = (a) => {
    const age = parseInt(a, 10) || 40;
    if (age < 30) return 0.85;
    if (age < 45) return 1.0;
    if (age < 60) return 1.35;
    if (age < 70) return 1.9;
    return 2.5;
  };
  const baseByLevel = { basic: 48, standard: 78, premium: 128 };
  const level = data.coverLevel || 'standard';
  let perPerson = baseByLevel[level] || 78;
  perPerson += data.noCopay ? 18 : 0;
  perPerson += data.dental ? 9 : 0;
  perPerson += data.maternity ? 22 : 0;
  perPerson += data.mentalHealth ? 8 : 0;
  perPerson += data.international ? 24 : 0;
  perPerson += data.privateRoom ? 12 : 0;
  perPerson += data.optical ? 6 : 0;
  perPerson += data.smoker ? 18 : 0;
  perPerson += data.chronicConditions ? 25 : 0;

  const totalMonthly = applicants.reduce((sum, a) => sum + perPerson * ageFactor(a.age), 0);
  const highlights = [
    data.noCopay ? 'No copay' : 'With copay',
    data.dental ? 'Full dental' : 'Basic dental',
    data.maternity ? 'Maternity included' : 'No maternity',
    data.mentalHealth ? 'Mental health cover' : null,
    data.international ? 'Worldwide emergency' : 'Spain only',
    data.privateRoom ? 'Private room guaranteed' : null,
  ].filter(Boolean);
  return HEALTH_INSURERS.map((insurer, i) => ({
    insurer: insurer.name,
    rating: insurer.rating,
    premium_monthly: round(totalMonthly * (0.92 + i * 0.05)),
    premium: round(totalMonthly * (0.92 + i * 0.05) * 12),
    highlights,
  })).sort((a, b) => a.premium_monthly - b.premium_monthly);
}
